import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import {objectToQueryParams} from "@/utils/publicFun";
import ListView from "@/components/AntListView";

/**
 * @description 查看更多
 * @return {/culturalExchange_taijigreencarbon/MorePage}
 */

const MorePage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    // if (window.JsBridge.hasWebViewBridge()) {
    //     window.JsBridge.back();
    //   } else {
    //     navigate(-1);
    //   };
      navigate(-1);
  }
  
  return (
    <div className={Styles.morePage}>
      {/* 状态栏 */}
      {/* <div className={Styles.statusBar}></div> */}

      {/* 导航栏 */}
      

      {/* 内容区域 */}
      <div className={Styles.content}>
        <div className={Styles.navBar}>
          <div className={Styles.backButton} onClick={handleBack}></div>
          <div className={Styles.title}></div>
          <div className={Styles.placeholder}></div>
        </div>
        <img className={Styles.moreImg} src={require('@/assets/img/culturalExchange_taijigreencarbon/more1.jpg')} alt="" />
        <img className={Styles.moreImg} src={require('@/assets/img/culturalExchange_taijigreencarbon/more2.jpg')} alt="" />
        <img className={Styles.moreImg} src={require('@/assets/img/culturalExchange_taijigreencarbon/more3.jpg')} alt="" />
        <img className={Styles.moreImg} src={require('@/assets/img/culturalExchange_taijigreencarbon/more4.jpg')} alt="" />
      </div>
    </div>
  )
}

export default MorePage
